module.exports = __webpack_public_path__ + "static/media/gryphon-house-club-lounge.0232a628.jpeg";